import { createFileRoute } from '@tanstack/react-router'
import MarketingAutomacoesEditPage from '@/pages/dashboard/marketing-automacoes-edit-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/',
)({
  component: function MarketingAutomacoesEditRoute() {
    const { dashboardId, automacaoId } = Route.useParams()

    return (
      <RequireModule module={MODULES.AUTOMACOES} dashboardId={dashboardId}>
        <MarketingAutomacoesEditPage
          mode="edit"
          dashboardId={dashboardId}
          automacaoId={automacaoId}
        />
      </RequireModule>
    )
  },
})
